import { FAIcon } from "./faIcon.js";
import { General } from "../../../siteManagement/general.js";
import { Config } from "../config/config.js";
import React from "react";
import ReactDOM from "react-dom";

export class PageTitle extends React.Component<PageTitleProps, any>{
    private _sheetRemarksDomRef: JQuery = null;
    private _title: string = null;
    private _id: string = null;

    constructor(props) {
        super(props)
        const sheet = General.Sheet.Manager.getTopMostSheet();
        this._sheetRemarksDomRef = sheet.elements.getTitleRemarksRef();
        this._id = sheet.id();
        this._title = this.props.title;
        sheet.setTitle(this.props.title);
    }

    render() {
        if (this._title != this.props.title) {
            let sheet = General.Sheet.Manager.getSheetById(this._id);
            if (sheet == null)
                sheet = General.Sheet.Manager.getTopMostSheet();
            this._title = this.props.title;
            sheet.setTitle(this.props.title);
        }
        return (
            <>
                {
                    ReactDOM.createPortal(
                        <>
                            {
                                this.props.locked === true ?
                                    <FAIcon name="lock-alt" wrapperToolTip={this.props.lockInfo} wrapperClass="lock-icon lock-icon--locked" />
                                    : null
                            }
                            {
                                this.props.followed === true ?
                                    <FAIcon name="eye" wrapperToolTip={Config.translations.followed} style={{ marginLeft: "10px" }} />
                                    : null
                            }
                        </>
                        , this._sheetRemarksDomRef[0])
                }
            </>
        );
    }
}

export interface PageTitleProps {
    title: string;
    value?: any;
    locked?: boolean;
    lockInfo?: string;
    followed?: boolean;
}